import { render, staticRenderFns } from "./EventInviteModal.vue?vue&type=template&id=7153a5a5"
import script from "./EventInviteModal.vue?vue&type=script&lang=js"
export * from "./EventInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports